(function () {
  const btn = document.querySelector('[data-bv-music]');
  if (!btn) return;

  const src = btn.getAttribute('data-src');
  if (!src) return;

  const stateKey = 'bv_music_state';
  const timeKey = 'bv_music_time';

  let audio = window.__bvAudio;
  if (!audio) {
    audio = new Audio(src);
    audio.loop = true;
    audio.volume = 0.45;
    audio.preload = 'auto';
    window.__bvAudio = audio;
  }

  const setPlaying = (playing) => {
    btn.setAttribute('data-playing', playing ? 'true' : 'false');
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    btn.setAttribute('aria-label', playing ? 'Pause soundtrack' : 'Play soundtrack');
  };

  // Restore prior position across navigations
  const storedTime = parseFloat(sessionStorage.getItem(timeKey) || '0');
  if (!isNaN(storedTime) && storedTime > 0) {
    try { audio.currentTime = storedTime; } catch (e) { /* ignore */ }
  }

  // Resume playback only if user previously opted-in this session.
  // Browsers block autoplay without prior gesture, so this may silently fail
  // until the user clicks — that's intentional, the pill stays in paused state.
  const stored = sessionStorage.getItem(stateKey);
  if (stored === 'playing') {
    audio.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
  } else {
    setPlaying(false);
  }

  btn.addEventListener('click', () => {
    if (audio.paused) {
      audio.play().then(() => {
        setPlaying(true);
        sessionStorage.setItem(stateKey, 'playing');
      }).catch(() => {
        setPlaying(false);
      });
    } else {
      audio.pause();
      setPlaying(false);
      sessionStorage.setItem(stateKey, 'paused');
      sessionStorage.setItem(timeKey, String(audio.currentTime));
    }
  });

  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem(timeKey, String(audio.currentTime));
  });

  setInterval(() => {
    if (!audio.paused) {
      sessionStorage.setItem(timeKey, String(audio.currentTime));
    }
  }, 4000);
})();
